import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/social/react-stories/src/instagram-story.tsx");
